export const register = 'auth/register'
export const login = 'auth/login'
export const login2fa = 'auth/login/2fa'
export const verifyEmail = 'auth/verify-email'
export const forgotPassword = 'auth/forgot-password'
export const resetPassword = 'auth/reset-password'
export const validateToken = 'auth/validate-token'
export const waitlist = 'waiting-lists'
export const staffs = 'staffs'
export const estateStaff = 'estates/staffs'
export const staffEstates = 'staffs/estates'
export const staffEstatesAccess = 'staffs/estates/get-access'
export const estates = 'estates'

export const estateResidents = 'estates/residents'
export const contactUs = '/contact-us'
// export const residentType = "estates/{estateId}/resident-types";
export const landlords ="residents"
export const properties = 'estates/properties'
export const residentTypes = '/estates/resident-types'
export const residents = '/estates/residents'
export const staffInvitation = '/staffs/invitations'
export const propertyOwner = (propertyId: string) => `estates/properties/${propertyId}/owner`
export const propertyTenants = (propertyId: string) => `estates/properties/${propertyId}/tenants`
export const propertyApproval = (propertyId: string) => `Estates/properties/${propertyId}/approval`;
export const residentType = (estateId: string) => {
  return `estates/${estateId}/resident-types`
}
export const addResidentType = (estateId: string) => `estates/${estateId}/resident-types`
export const updateResidentType = (estateId: string, residentTypeId: string) =>
  `estates/${estateId}/resident-types/${residentTypeId}`
export const loggedInStaff = '/staffs/me'
export const uploadFiles = '/uploads/file'
export const activities = '/activities'
export const changePassword="staffs/me/password"

export const removeStaff = '/estates/staff'
export const sendVerificationEmail = '/auth/send-verification-email'
export const getAllGuest = '/estates/guests'

export const Guests = '/estates/guests'
export const guestEntry = (code: string) => `estates/guests/${code}/entry`

export const services = (estateId: string) => `estates/${estateId}/services`
export const artisans = '/estates/artisans'
export const serviceRequest = '/estates/service-requests'
export const UpdateRequestStatus =  (requestId: string) => `/estates/service-requests/${requestId}/status`
export const feedback = '/feedbacks'
export const communityFeedback = (estateId: string) => `/staffs/communities/${estateId}/feedbacks`

// ── Banking ───────────────────────────────────────────────────────────────────
export const listBanks = '/banking/list-banks'
export const verifyAccountNumber = '/banking/verify-account-number'
export const estatePayoutAccount = '/estates/payout-account'

// ── Estate Verification ─────────────────────────────────────────────────────
export const estateVerification = (estateId: string) =>
  `estates/${estateId}/verification`

// ── Mailing List ────────────────────────────────────────────────────────────────
export const subscribeNewsletter = '/mailing-list/subscribe'
export const unsubscribeNewsletter = '/mailing-list/unsubscribe'


export const residentMembership = (communityMemberId: string) => `estates/residents/${communityMemberId}/membership`

export const residentAccessLogs = (propertyMemberId: string) => `estates/residents/${propertyMemberId}/access-logs`

export const enableDisableResidentAction = (propertyMemberId: string, disableOrEnableResidentAction: string) => `estates/residents/${propertyMemberId}/${disableOrEnableResidentAction}`

